import { Directive, HostListener, Self } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

// Toggletip: pressing a button whose tooltip holds its information (click, tap, Enter or Space) shows the tooltip at
// once, so the button does something when pressed and touch users get the text with a tap (Material only shows a
// tooltip on hover, keyboard focus or a long press). It stays until focus or the pointer leaves, or Escape.
// Applies to the ⓘ info buttons and to status chips with a message (StatusChipComponent renders those as
// button.toggletip). show() rather than toggle(): hover and focus already open it, so a toggle would close it on the
// first press; show() on an open tooltip also cancels a pending hide (a tap schedules one)
@Directive({
  selector: 'button.info-button[matTooltip], button.toggletip[matTooltip]',
  standalone: false
})
export class ToggletipDirective {
  constructor(@Self() private tooltip: MatTooltip) {}

  @HostListener('click')
  onClick(): void {
    this.tooltip.show(0);
  }
}
